import { z } from 'zod';

const searchTextSchema = z.preprocess(
  (value) => (typeof value === 'number' ? String(value) : value),
  z.string().trim().optional()
);

export const callsSearchSchema = z.object({
  search: searchTextSchema,
  agentId: z.number().int().optional(),
  pageSize: z.number().int().positive().optional(),
  sortField: z.string().trim().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
});

export type CallsSearch = z.infer<typeof callsSearchSchema>;
